"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = parseConfig;
var _exenv = require("exenv");
function parseConfig() {
  if (_exenv.canUseDOM) {
    var clientConfig = document.getElementById('__clientConfig');
    // eslint-disable-next-line no-underscore-dangle
    if (!window.__CLIENT_CONFIG__ && clientConfig) {
      // eslint-disable-next-line no-underscore-dangle
      window.__CLIENT_CONFIG__ = JSON.parse(clientConfig.innerText);
    }

    // eslint-disable-next-line no-underscore-dangle
    return window.__CLIENT_CONFIG__ || {};
  }
  return {};
}